import { For, type JSX, Show } from 'solid-js';
import type { LiveTone } from '../lib/fleet-live';

// A Fleet Live panel's legend (#6778): a dot and a word per colour, and, on the Command
// Deck, the fold line "Showing the 16 busiest of N machines" past 16 online. The Topology
// keeps its own entries (owner ruling V9 #2), so each panel passes its own.

export type LegendEntry = { readonly tone: LiveTone; readonly label: string };

export function FleetLiveLegend(props: {
  readonly entries: readonly LegendEntry[];
  readonly fold?: string | null;
}): JSX.Element {
  return (
    <ul class="fleet-live__legend">
      <For each={props.entries}>
        {(e) => (
          <li>
            <i class={`fleet-live__swatch fleet-live__swatch--${e.tone}`} aria-hidden="true" />
            {e.label}
          </li>
        )}
      </For>
      <Show when={props.fold}>{(fold) => <li class="fleet-live__fold">{fold()}</li>}</Show>
    </ul>
  );
}
